import _objectWithoutProperties from "@babel/runtime/helpers/esm/objectWithoutProperties";
/* stylelint-disable no-descending-specificity */

import React from 'react';
import styled, { css } from 'styled-components';
import { gray25, gray45, gray10, gray60, gray75, white } from '@spotify-internal/encore-foundation';
import { buttonReset } from "../../styles";

var isDarkTheme = function isDarkTheme(props) {
  return props.theme.textLink === 'dark';
}; // eslint-disable-next-line prefer-arrow-callback


export default styled(function TextLink(_ref) {
  var _ref$component = _ref.component,
      Component = _ref$component === void 0 ? 'a' : _ref$component,
      props = _objectWithoutProperties(_ref, ["component"]);

  return React.createElement(Component, props);
}).withConfig({
  displayName: "Link",
  componentId: "zupq9f-0"
})(["", ";display:inline-flex;align-items:center;color:", ";&:hover:not([disabled]):not(:focus){text-decoration:underline;}&:focus:not([disabled]){color:", ";outline:none;text-decoration:underline;}&:active:not([disabled]){color:", ";text-decoration:underline;}&[disabled]{opacity:0.4;cursor:not-allowed;}"], function (props) {
  return props.component === 'button' && css(["", ";"], buttonReset());
}, function (props) {
  return isDarkTheme(props) ? gray60 : gray45;
}, function (props) {
  return isDarkTheme(props) ? white : gray10;
}, function (props) {
  return isDarkTheme(props) ? gray75 : gray25;
});